import request from '../request';
import { HistorySubcriber, IParamsSearchHistorySubcribe } from 'src/@types/search-params';
import axios from 'axios';
import qs from 'qs';
import {
  Sim900WaitingActivationDetail,
  Sim900WaitingActivationListResponse,
  Sim900WaitingActivationSearchParams,
} from 'src/shared/interface/sim900.interface';

export const getInfoActiveSim = async (params: any) => {
  const res = await request('get', `/api/user-profile/get-info-active-sim`, params);

  if (res.isSucceeded) {
    return res.data;
  }
};

export const getInfoActiveSimDetail = async (serial: string, phone: string) => {
  const res = await request(
    'get',
    `/api/user-profile/get-detail-info-active-sim?serial=${serial}&phone=${phone}`,
  );

  if (res.isSucceeded) {
    return res.data;
  }
};

export const getSimHistoryChange = async (params: IParamsSearchHistorySubcribe) => {
  const res = await request('get', `/api/user-profile/search-history-subcriber`, params);

  if (res.isSucceeded) {
    return res.data;
  }
};

export const getAllPackage = async () => {
  const res = await axios.get(`${process.env.REACT_APP_PORTAL_MLC}/public/meta`);

  if (res.data) {
    return res.data;
  }
};

export const getAllPackageByLCS = async () => {
  const res = await request('get', `/api/Provider/register-package/data-package/0`);

  if (res.data) {
    return res.data;
  }
};

export const exportInfoActiveSim = async (searchParams = {}) => {
  const res = await request('post', `/api/user-profile/export-info-active-sim`, searchParams, {
    paramsSerializer: {
      serialize: (searchParams) => qs.stringify(searchParams, { arrayFormat: 'repeat' }),
    },
    responseType: 'blob',
  });

  if (res.isSucceeded) {
    return res;
  }
};
export const getEnumActionTypeManagement = async () => {
  const res = await request('get', `/api/user-profile/action-type-management`);

  if (res.isSucceeded) {
    return res.data;
  }
};
export const getSearchDetailHistorySubcriber = async (data: HistorySubcriber) => {
  const res = await request('post', `/api/user-profile/search-detail-history-subcriber`, data);

  if (res.isSucceeded) {
    return res.data;
  }
};
export const getSearchActiveSim = async (params: any) => {
  const res = await request('get', `/api/user-profile/search-info-active-sim`, params);

  if (res.isSucceeded) {
    return res.data;
  }
};

export const getAllSim900WaitingActivation = async (
  params: Sim900WaitingActivationSearchParams,
) => {
  const res = await request<Sim900WaitingActivationListResponse>(
    'get',
    `/api/active-sim/sim900/get-all`,
    params,
  );

  if (res.isSucceeded) {
    return res.data;
  }
};

export const getSim900WaitingActivationById = async (id: string) => {
  const res = await request<Sim900WaitingActivationDetail>('get', `/api/active-sim/sim900/${id}`);

  if (res.isSucceeded) {
    return res.data;
  }
};
